import { Link, createFileRoute, useParams } from '@tanstack/react-router'

import { useCopy } from '@/lib/copy/use-copy'

import { useContact } from '@/features/directory/queries'

export const Route = createFileRoute('/_authed/directory/$id')({
  component: () => {
    const { id } = useParams({ from: '/_authed/directory/$id' })
    const copy = useCopy()
    const d = copy.shell.directory
    const { data: contact, isLoading } = useContact(id)
    if (isLoading) return <p className="p-6">Ladowanie...</p>
    if (!contact) return <p className="p-6">Nie znaleziono kontaktu.</p>
    return (
      <section className="space-y-3 p-6">
        <h1 className="text-2xl">
          {contact.firstName} {contact.lastName ?? ''}
        </h1>
        <p className="text-sm text-white/70">
          {d.dob}: {contact.birthDate}
        </p>
        <Link
          to="/directory/$id/edit"
          params={{ id }}
          className="text-sm underline"
        >
          {d.editShort}
        </Link>
      </section>
    )
  },
})
